<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	export default {
		name: 'App',
		created() {

		},
		methods: {
		}
	}
</script>

<style lang='less'>
	* {
		margin: 0;
		padding: 0;
	}

	html,
	body {
		width: 100%;
		height: 100%;
		/* ::-webkit-scrollbar{
		  width:6px;
		  height:6px;
		}
		::-webkit-scrollbar-track{
		  background: rgb(239, 239, 239);
		  border-radius:2px;
		}
		::-webkit-scrollbar-thumb{
		  background: #bfbfbf;
		  border-radius:6px;
		}
		::-webkit-scrollbar-corner{
		  background: #179a16;
		} */
	}
	.el-image-viewer__wrapper{
	z-index: 9999!important;
  }
</style>
<style lang="less" scoped>
	#app {
		width: 100%;
		height: 100%;
	}
	::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }
  ::v-deep input[type='number'] {
    -moz-appearance: textfield;
  }
</style>
